import Vue from 'vue';
import App from './App';
import Vuetify from 'vuetify';
import router from './router';
import store from './store';

import 'font-awesome/css/font-awesome.css';
import './theme/default.styl';
import VeeValidate from 'vee-validate';
import Truncate from 'lodash.truncate';
import 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import '@/utils/googleapis/googlemap.js';
import '@/utils/googleapis/googlefonts.css';
import 'vuetify/dist/vuetify.min.css';
import VueIframe from 'vue-iframes';
import axios from 'axios';
import VueAxios from 'vue-axios'

Vue.use(VueIframe)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false;

Vue.filter('truncate', Truncate);
Vue.use(VeeValidate, { fieldsBagName: 'formFields' });
Vue.use(Vuetify, {
  options: {
    themeVariations: ['primary', 'secondary', 'accent'],
    extra: {
      mainToolbar: {
        color: 'primary'
      },
      sideToolbar: {},
      sideNav: 'primary',
      mainNav: 'primary lighten-1',
      bodyBg: ''
    }
  },

});

// eslint-disable-next-line
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js